import React from "react";
import productsData from "../data/products";

const FeaturedProducts = () => {
  const selectedIds = [13, 22, 39, 120, 136, 154, 167, 185, 189, 206, 241, 247];

  const featuredProducts = productsData.filter(product =>
    selectedIds.includes(product.id)
  );

  return (
    <section className="featured-products-section">
      <div className="container">

        <div className="text-center mb-5">
          <h6 className="section-subtitle">PRODUCT HIGHLIGHTS</h6>
          <h2 className="section-title">
            Our <span>Featured Products</span>
          </h2>
          <p className="section-desc">
            A glimpse of our wide range of trusted crop protection and
            agricultural solutions used by farmers across India.
          </p>
        </div>

        <div className="row">
          {featuredProducts.map((productsData) => (
            <div className="col-xl-3 col-lg-4 col-md-6 mb-4" key={productsData.id}>
              <div className="product-card">

                <div className="product-img">
                  <img src={productsData.image} alt={productsData.name} />
                  <span className="product-category">
                    {productsData.category}
                  </span>
                </div>

                <div className="product-info">
                  <h5>{productsData.name}</h5>
                  <p><strong>Technical:</strong> {productsData.technical}</p>
                  <p><strong>Formulation:</strong> {productsData.formulation}</p>
                  <p className="pack">
                    <strong>Pack Size:</strong> {productsData.packSize}
                  </p>
                </div>

              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-4">
          <a href="/products" className="view-all-btn">
            View All 260+ Products
          </a>
        </div>

      </div>
    </section>
  );
};

export default FeaturedProducts;
